import {
  MonitoringChartData,
  MonitroingMetricsPreferenciesListItem,
} from '@app/monitoring/common/monitoring-metrics.types';
import { MonitoringChartPeriod } from '@app/monitoring/monitoring.constants';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

const MonitoringMetricsActionGroup = createActionGroup({
  source: 'Monitoring Metrics',
  events: {
    // setSearchValue
    'Set Search Value': (payload: { value: string }) => ({ payload }),
    // loadMonitoringMetrics
    'Load Monitoring Metrics': props<{ period: MonitoringChartPeriod }>(),
    // loadMonitoringMetricsDataSuccess
    'Load Monitoring Metrics Data Success': props<{
      category: string[];
      series: MonitoringChartData[];
      currency_multiplication: string;
      currency: string;
    }>(),
    // loadMonitoringMetricsDataFailure
    'Load Monitoring Metrics Data Failure': emptyProps(),
    // setMetricPreference
    'Set Monitoring Metric Preference': (payload: MonitroingMetricsPreferenciesListItem) => ({ payload }),
    // setMonitoringPeriod
    'Set Monitoring Period': (payload: { value: MonitoringChartPeriod }) => ({ payload }),
    // setAllChartShowing
    'Set All Chart Showing': (payload: boolean) => ({ payload }),
  },
});

export const {
  setSearchValue,
  loadMonitoringMetrics,
  loadMonitoringMetricsDataSuccess,
  loadMonitoringMetricsDataFailure,
  setMonitoringMetricPreference,
  setMonitoringPeriod,
  setAllChartShowing,
} = MonitoringMetricsActionGroup;
